export const INCIDENT_STATUS_OPTIONS = [
  { value: "open", label: "Open" },
  { value: "investigating", label: "Investigating" },
  { value: "contained", label: "Contained" },
  { value: "resolved", label: "Resolved" },
  { value: "closed", label: "Closed" },
  { value: "false_alarm", label: "False Alarm" },
];

export const INCIDENT_CATEGORIES = [
  { id: "email_security", name: "Email Security" },
  { id: "computer_device", name: "Computer/Device Security" },
  { id: "network_access", name: "Network & Access" },
  { id: "data_privacy", name: "Data & Privacy" },
  { id: "identity_auth", name: "Identity & Authentication" },
  { id: "physical_security", name: "Physical Security" },
  { id: "social_engineering", name: "Social Engineering" },
  { id: "other", name: "Other Security Concerns" },
];

export const INCIDENT_CATEGORIES_WITH_OPTIONS = [
  {
    id: "email_security",
    name: "Email Security",
    placeholder: "Select Email Security incident...",
    options: [
      "Phishing Email",
      "Suspicious Attachment",
      "Spam/Unsolicited Email",
      "Business Email Compromise",
      "Email Spoofing",
    ],
  },
  {
    id: "computer_device",
    name: "Computer/Device Security",
    placeholder: "Select Computer/Device Security incident...",
    options: [
      "Malware/Virus Detected",
      "Ransomware",
      "Unauthorized Software",
      "Lost/Stolen Device",
      "System Compromise",
    ],
  },
  {
    id: "network_access",
    name: "Network & Access",
    placeholder: "Select Network & Access incident...",
    options: [
      "Unauthorized Network Access",
      "VPN Issues",
      "Suspicious Network Activity",
      "DDoS Attack",
      "Firewall Breach",
    ],
  },
  {
    id: "data_privacy",
    name: "Data & Privacy",
    placeholder: "Select Data & Privacy incident...",
    options: [
      "Data Breach",
      "Data Leak",
      "Privacy Violation",
      "Unauthorized Data Access",
      "Data Loss",
    ],
  },
  {
    id: "identity_auth",
    name: "Identity & Authentication",
    placeholder: "Select Identity & Authentication incident...",
    options: [
      "Account Compromise",
      "Credential Theft",
      "MFA Bypass",
      "Unauthorized Login",
      "Password Breach",
    ],
  },
  {
    id: "physical_security",
    name: "Physical Security",
    placeholder: "Select Physical Security incident...",
    options: [
      "Tailgating/Piggybacking",
      "Unauthorized Physical Access",
      "Stolen Badge/Key",
      "Suspicious Person",
      "Equipment Theft",
    ],
  },
  {
    id: "social_engineering",
    name: "Social Engineering",
    placeholder: "Select Social Engineering incident...",
    options: [
      "Vishing (Phone Scam)",
      "Pretexting",
      "Baiting",
      "Impersonation",
      "Tailgating",
    ],
  },
  {
    id: "other",
    name: "Other Security Concerns",
    placeholder: "Select Other Security Concerns incident...",
    options: [
      "Policy Violation",
      "Compliance Issue",
      "Suspicious Activity",
      "Security Concern",
      "Other",
    ],
  },
];

// Mapping of incident subtypes to category IDs
export const SUBTYPE_TO_CATEGORY = {
  // Category names (from title field in DB)
  "email security": "email_security",
  "computer/device security": "computer_device",
  "network & access": "network_access",
  "data & privacy": "data_privacy",
  "identity & authentication": "identity_auth",
  "physical security": "physical_security",
  "social engineering": "social_engineering",
  "other security concerns": "other",
  
  // Full subtype names
  "phishing email": "email_security",
  "suspicious attachment": "email_security",
  "spam/unsolicited email": "email_security",
  "business email compromise": "email_security",
  "email spoofing": "email_security",
  "malware/virus detected": "computer_device",
  "ransomware": "computer_device",
  "unauthorized software": "computer_device",
  "lost/stolen device": "computer_device",
  "system compromise": "computer_device",
  "unauthorized network access": "network_access",
  "vpn issues": "network_access",
  "suspicious network activity": "network_access",
  "ddos attack": "network_access",
  "firewall breach": "network_access",
  "data breach": "data_privacy",
  "data leak": "data_privacy",
  "privacy violation": "data_privacy",
  "unauthorized data access": "data_privacy",
  "data loss": "data_privacy",
  "account compromise": "identity_auth",
  "credential theft": "identity_auth",
  "mfa bypass": "identity_auth",
  "unauthorized login": "identity_auth",
  "password breach": "identity_auth",
  "tailgating/piggybacking": "physical_security",
  "unauthorized physical access": "physical_security",
  "stolen badge/key": "physical_security",
  "suspicious person": "physical_security",
  "equipment theft": "physical_security",
  "vishing (phone scam)": "social_engineering",
  "pretexting": "social_engineering",
  "baiting": "social_engineering",
  "impersonation": "social_engineering",
  "tailgating": "social_engineering",
  "policy violation": "other",
  "compliance issue": "other",
  "suspicious activity": "other",
  "security concern": "other",
  "other": "other",
  
  // Backend category IDs
  "email_security": "email_security",
  "computer_device": "computer_device",
  "network_access": "network_access",
  "data_privacy": "data_privacy",
  "identity_auth": "identity_auth",
  "physical_security": "physical_security",
  "social_engineering": "social_engineering",
  
  // Legacy/alternate backend values
  "phishing": "email_security",
  "malware": "computer_device",
  "data_leak": "data_privacy",
  "security_breach": "other",
};

export const DEPARTMENTS_WITH_DESIGNATIONS = [
{
  id: "executive_management",
  name: "Executive Management",
  roles: [
    {
      id: "ceo",
      role: "CEO / Managing Director",
      responsibility: "Executive Oversight, Final Approvals",
      reports_to: null
    },
    {
      id: "coo",
      role: "COO",
      responsibility: "Governance Oversight, Program Sponsor",
      reports_to: "ceo"
    },
    {
      id: "cto",
      role: "CTO / CIO",
      responsibility: "Technology Risk Owner, Strategic Approver",
      reports_to: "ceo"
    },
    {
      id: "ciso",
      role: "CISO",
      responsibility: "Enterprise Security Strategy and Governance",
      reports_to: "cto"
    },
    {
      id: "management_representatives",
      role: "Management Representatives",
      responsibility: "Management Oversight and Policy Support",
      reports_to: "coo"
    },
    {
      id: "business_unit_head",
      role: "Department / Business Unit Head",
      responsibility: "Risk Owner, Policy Approver",
      reports_to: "coo"
    }
  ]
},

{
  id: "information_technology",
  name: "Information Technology (IT)",
  roles: [
    {
      id: "it_manager",
      role: "IT Manager",
      responsibility: "Control Owner, Risk Owner",
      reports_to: "cto"
    },
    {
      id: "system_administrator",
      role: "System Administrator",
      responsibility: "Control Implementer",
      reports_to: "it_manager"
    },
    {
      id: "network_administrator",
      role: "Network Administrator",
      responsibility: "Control Implementer",
      reports_to: "it_manager"
    },
    {
      id: "application_administrator",
      role: "Application Administrator",
      responsibility: "Control Implementer",
      reports_to: "it_manager"
    },
    {
      id: "it_support_engineer",
      role: "IT Support / Helpdesk Engineer",
      responsibility: "Issue Remediation Support",
      reports_to: "it_manager"
    },
    {
      id: "it_operations",
      role: "IT Operations",
      responsibility: "Infrastructure Operations Management",
      reports_to: "it_manager"
    },
    {
      id: "it_asset_manager",
      role: "IT Asset Manager",
      responsibility: "IT Asset Lifecycle Management",
      reports_to: "it_manager"
    },
    {
      id: "change_manager",
      role: "Change Manager",
      responsibility: "IT Change Management Process Owner",
      reports_to: "it_manager"
    }
  ]
},

{
  id: "engineering",
  name: "Engineering / Software Development",
  roles: [
    {
      id: "engineering_manager",
      role: "Engineering Manager",
      responsibility: "Secure Development Oversight, Risk Owner",
      reports_to: "cto"
    },
    {
      id: "software_architect",
      role: "Software Architect",
      responsibility: "Secure Architecture Design",
      reports_to: "engineering_manager"
    },
    {
      id: "development_lead",
      role: "Development Lead",
      responsibility: "Application Development Leadership",
      reports_to: "engineering_manager"
    },
    {
      id: "senior_software_engineer",
      role: "Senior Software Engineer",
      responsibility: "Secure Code Development, Vulnerability Fixes",
      reports_to: "development_lead"
    },
    {
      id: "software_developer",
      role: "Software Developer",
      responsibility: "Secure Coding Implementation",
      reports_to: "development_lead"
    },
    {
      id: "qa_test_engineer",
      role: "QA / Test Engineer",
      responsibility: "Security Testing Support",
      reports_to: "development_lead"
    }
  ]
}
];

export const DOCUMENT_LIBRARY_CATEGORIES = ['Document', 'Policy', 'Record', 'Artifact'];

export const CONTROL_CATEGORIES = [
  
    "Context & Scope",
    "Governance",
    "Leadership",
    "Organizational",
    "Compliance",
    "Data Inventory",
    "Risk Management",
    "Design Controls",
    "Data Management",
    "Data Subject Rights",
    "Data Protection Techniques",
    "Transfers",
    "Third-Party",
    "Security Controls",
    "Incident Response",
    "Audit & Monitoring",
    "Performance",
    "Records Management",
    "Development Controls",
    "Transparency",
    "Continuity",
    "Support",
    "Processing Controls",
    "Improvement",
    "Information Security Governance",
    "Roles and Responsibilities",
    "Board Oversight",
    "Independent Review",
    "Policy Framework",
    "Security Capability",
    "Training and Awareness",
    "Resource Allocation",
    "Third-Party Skills",
    "Technology Management",
    "Information Assets",
    "Ownership",
    "Asset Inventory",
    "Critical Asset Identification",
    "Third-Party Assets",
    "Control Design",
    "Defense in Depth",
    "Preventive Controls",
    "Detective Controls",
    "Corrective Controls",
    "Change Management",
    "Access Control",
    "Authentication",
    "Encryption",
    "Network Security",
    "Testing and Exercises",
    "Notification",
    "Root Cause Analysis",
    "Continuous Improvement",
    "Third-Party Risk",
    "Contractual Obligations",
    "Monitoring",
    "Subcontractor Controls",
    "Termination",
    "Governance and Oversight",
    "Asset and Data Management",
    "Data Protection and Privacy",
    "Operations Security",
    "Threat and Vulnerability Management",
    "Business Continuity",
    "Compliance and Audit",
    "Governance & Accountability",
    "Lawful Processing",
    "Data Processing Principles",
    "Data Quality",
    "Data Security",
    "Risk & Compliance",
    "Incident Management",
    "Data Lifecycle Management",
    "Cross-Border Transfers",
    "Third-Party Management",
    "Awareness & Training",
    "Monitoring & Auditing",
    "Information Governance",
    "Privacy by Design",
    "Sensitive Data",
    "Resilience",
    "Compliance Management",
    "Principles",
    "Consumer Rights",
    "Business Obligations",
    "Rights Management",
    "Security",
    "AI / CPRA Additions",
    "Operational / Compliance",
    "Inventory and Control of Enterprise Assets",
    "Inventory and Control of Software Assets",
    "Data Protection",
    "Secure Configuration of Enterprise Assets and Software",
    "Account Management",
    "Security Awareness and Skills Training",
    "Malware Defenses",
    "Email and Web Browser Protections",
    "Data Recovery",
    "Network Infrastructure Management",
    "Service Provider Management",
    "Security Monitoring",
    "Incident Response Management",
    "Penetration Testing",
    "Application Software Security",
    "Data Protection and Governance",
    "Testing and Validation",
    "Management",
    "Delivery",
    "Operations",
    "Firewalls & Internet Gateways",
    "Secure Configuration",
    "User Access Control",
    "Malware Protection",
    "Security Update Management",
    "Verification and Testing",
    "Asset Management",
    "Cryptography",
    "System Security",
    "Cloud Security",
    "OT/ICS Security",
    "Physical Security",
    "Supply Chain",
    "End-User",
    "Misc",
    "ICT Risk Management",
    "ICT Incident Reporting",
    "Digital Operational Resilience Testing",
    "ICT Third-Party Risk Management",
    "Information Sharing",
    "Cross-cutting Governance & Assurance",
    "Operational",
    "Ethics",
    "Privacy",
    "Controller Obligations",
    "Data Transfers",
    "Accountability",
    "Identifying Purposes",
    "Consent",
    "Limiting Collection",
    "Retention & Disposal",
    "Safeguards & Security",
    "Openness",
    "Individual Participation",
    "Accountability & Oversight",
    "Breach Response",
    "PETs & Minimization",
    "Security Architecture",
    "Innovation & Projects",
    "Operational Controls",
    "Special Categories",
    "Technology & Security",
    "Resilience & Continuity",
    "Emerging Tech & AI",
    "Requirement 1 - Network Security Controls",
    "Requirement 2 - Secure Configurations",
    "Requirement 3 - Protect Stored Cardholder Data",
    "Requirement 4 - Data Transmission Security",
    "Requirement 5 - Malware Protection",
    "Requirement 6 - Secure Development & Maintenance",
    "Requirement 7 - Access Control",
    "Requirement 8 - Identification & Authentication",
    "Requirement 9 - Physical Security",
    "Requirement 10 - Logging & Monitoring",
    "Requirement 11 - Testing & Validation",
    "Requirement 12 - Governance & Policy",
    "Core Principles",
    "Legal Basis",
    "Lawfulness & Transparency",
    "Consent & Purpose Limitation",
    "Data Management & Security",
    "Third-party Oversight",
    "AI & Automated Decisions",
    "Audit & Continuous Improvement",
    "Project Management",
    "Technology Operations",
    "Security Management",
    "Cloud & Emerging Tech",
    "System Development",
    "Business Environment",
    "Risk Assessment",
    "Risk Management Strategy",
    "Supply Chain Risk",
    "Data Classification",
    "Legal & Regulatory",
    "Asset Lifecycle",
    "Business Impact Analysis",
    "Third-Party Inventory",
    "Asset Ownership",
    "Protective Technology",
    "Maintenance",
    "Endpoint Detection",
    "Threat Intelligence",
    "Network Monitoring",
    "Baseline Behavior",
    "Monitoring Coverage",
    "Log Retention",
    "Alert Triage",
    "Detection Testing",
    "Insider Threat Detection",
    "Response Planning",
    "Communications",
    "Analysis",
    "Mitigation",
    "Stakeholder Coordination",
    "Escalation",
    "Incident Playbooks",
    "Forensic Readiness",
    "Incident Logging",
    "Tabletop Exercises",
    "Third-Party Response",
    "Recovery Planning",
    "Backup Restoration",
    "Alternate Sites",
    "Data Integrity",
    "Post-Recovery Review",
    "Service Restoration",
    "Supplier Recovery",
    "Insurance & Financial"
  ]

export const framework_categories = [
  {
    value: "global_security_and_risk_frameworks",
    name: "Global Security & Risk Frameworks"
  },
  {
    value: "ai_innovation_and_emerging_tech_compliance",
    name: "AI, Innovation & Emerging Tech Compliance"
  },
  {
    value: "privacy_and_data_protection_regulations",
    name: "Privacy & Data Protection Regulations"
  },
  {
    value: "sector_specific_security_and_compliance",
    name: "Sector-Specific Security & Compliance"
  },
  {
    value: "government_and_national_cyber_regulations",
    name: "Government & National Cyber Regulations"
  }
];
